import { postRequest } from '../clients/axios';
import { SaveImageMetadataPayload, SaveImageMetadataResponse } from '../models/ImageMetadata';

export const postSaveImageMetadata = async (payload: SaveImageMetadataPayload) => {
  const response = await postRequest<SaveImageMetadataResponse>('storageObject/image/saveMetadata', payload);
  return response.data;
};
